<span class="growth" id="rc-container" [ngClass]="type">
  <img alt="trending arrow" class="rc-trending-icon" [src]="type === 'up' ? upIcon : downIcon" />
  <br />
  <strong [ngClass]="{'trending-down' : type === 'down', '' : type !== 'down'}">{{ value }}%</strong>
</span>
